import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import useAxiosInstance from "./utils/axiosIntance";

type CreateGamePayload = {
  playerName: string;
};

type CreateGameResponse = {
  isSuccess: boolean;
  gameId: string;
  id: string;
  name: string;
  isAdmin: boolean;
  isOnline: boolean;
  isReady: boolean;
};

const useCreateGame = () => {
  const axios = useAxiosInstance();
  const { mutate: createGame } = useMutation<
    AxiosResponse<CreateGameResponse>,
    AxiosError,
    CreateGamePayload
  >({
    mutationFn: (payload: CreateGamePayload) => {
      return axios.post(`/game`, payload, {
        withCredentials: true,
      });
    },
  });
  return createGame;
};

export default useCreateGame;
